import React, { useMemo } from 'react';

import { AlbumRow } from '../styles';
import { AlbumX1 } from './AlbumX1';

import { ALBUM_DEFAULT_MAX_WIDTH, ALBUM_GAP } from '../const';
import { JRCAlbumItemProps } from '../types';

export const AlbumX2 = ({ files, maxWidth = ALBUM_DEFAULT_MAX_WIDTH, onClick }: JRCAlbumItemProps) => {
    const { width, height } = useMemo(() => {
        return { width: Math.floor((maxWidth - ALBUM_GAP) / 2), height: Math.floor((maxWidth - ALBUM_GAP) / 2) };
    }, [maxWidth]);

    return (
        <AlbumRow>
            {files.map((file) => (
                <AlbumX1 key={file.uri} files={[file]} maxWidth={width} maxHeight={height} onClick={onClick} />
            ))}
        </AlbumRow>
    );
};
